<template>

    <div class="field">
        <div :class=" poll ? '' : 'field is-horizontal' ">
            <div v-show=" ! poll " class="field-label">
                <label for="AttachPoll" class="label">Attach a Poll?</label>
            </div>
            <div class="field-body is-block">
                <label v-show=" ! poll " class="xero-checkbox">
                    <xero-checkbox id="AttachPoll" @change="(data) => {opened = data === 'Yes';}" name="AttachPoll" value="Yes"></xero-checkbox>
                    <span></span>
                </label>
                <div class="poll-creation-wrapper" :class=" opened || poll ? 'is-opened' : '' ">
                    <div v-show=" ! poll ">
                        <br>
                        <div class="is-divider"></div>
                    </div>
                    <div>
                        <h2 v-show=" ! poll " class="title is-4 has-text-centered">Create a poll</h2>
                        <div class="field my-4">
                            <div class="label">
                                <label for="question" class="label">Question</label>
                            </div>
                            <div class="control">
                                <xero-input type="text" class="input" id="question" name="question" :value=" poll && poll.question ? poll.question : '' " placeholder="Poll Question/Title"></xero-input>
                            </div>
                        </div>

                        <fieldset v-show=" ! poll " class="field my-4">
                            <legend class="label">
                                <label class="label">Add Options</label>
                            </legend>
                            <div class="control">
                                <ul>
                                    <li v-for="(input, index) in inputs" class="field has-addons" style="margin-bottom:0;margin-top: 0.25rem;">
                                        <div class="control is-expanded">
                                            <xero-input type="text" class="input is-fullwidth" :name="'PollOptions[' + index + ']'" :value="input ? input : ''" placeholder="Enter a polling option..."></xero-input>
                                        </div>
                                        <div class="control">
                                            <button class="button is-danger is-light" type="button" @click="deleteOption(index)">X</button>
                                        </div>
                                    </li>
                                </ul>
                                <button type="button" class="button is-light is-primary is-small" @click="addPollOption">Add Option</button>
                            </div>
                        </fieldset>

                        <div class="field my-4">
                            <label class="xero-checkbox">
                                View Advanced Options
                                <xero-checkbox id="advanced-poll-options" @change="(data) => {advancedOptionsOpened = data === 'Yes';}" :checked=" poll ? 'checked' : false " name="AdvancedOptions" value="Yes"></xero-checkbox>
                                <span></span>
                            </label>
                        </div>
                        <div class="advanced-options-wrapper" :class=" advancedOptionsOpened ? 'is-opened' : '' ">
                            <br>
                            <fieldset class="field my-4">
                                <legend class="label">
                                    <label for="votingPrivilege" class="label">Who can vote?</label>
                                </legend>
                                <div class="control">
                                    <p class="help">Who is allowed to submit a vote on this Poll? This does NOT affect the visibility of the poll however!</p>
                                    <p class="select">
                                        <xero-select required name="votingPrivilege" id="votingPrivilege"
                                             :options="{
                                                '1': 'Members Only',
                                                '2': 'Active Members Only',
                                                '3': 'Volunteers Only',
                                                '6': 'Leadership Only',
                                                '7': 'Administrators Only'
                                             }"
                                             :defaultOption=" poll && poll.votingPrivilege ? poll.votingPrivilege : '1'">
                                        </xero-select>
                                    </p>
                                </div>
                            </fieldset>

                            <fieldset class="field my-4">
                                <legend class="label">
                                    <label for="maxVotesPerUser" class="label">Votes per User?</label>
                                </legend>
                                <div class="control">
                                    <p class="help">How many selections can a user make on the form?</p>
                                    <xero-input type="number" class="input is-small" min="0" :value=" poll && poll.maxVotesPerUser ? poll.maxVotesPerUser : 5 " name="maxVotesPerUser" id="maxVotesPerUser"></xero-input>
                                </div>
                            </fieldset>

                            <fieldset class="field my-4">
                                <legend class="label">
                                    <label for="userSubmissions" class="label">Submissions?</label>
                                </legend>
                                <div class="control">
                                    <p class="help">Can the user submit new poll options?</p>
                                    <div class="py-1">
                                        <label class="xero-radio">
                                            Yes
                                            <xero-radio name="userSubmissions" id="userSubmissions" :checked=" !poll || poll.userSubmissions === 1 ? 'checked' : false " value="1"></xero-radio>
                                            <span></span>
                                        </label>
                                    </div>
                                    <div class="py-1">
                                        <label class="xero-radio">
                                            No
                                            <xero-radio name="userSubmissions" :checked=" poll && poll.userSubmissions === 0 ? 'checked' : false " value="0"></xero-radio>
                                            <span></span>
                                        </label>
                                    </div>
                                </div>
                            </fieldset>

                            <fieldset class="field my-4">
                                <legend class="label">
                                    <label for="expiration" class="label">Poll Expiration</label>
                                </legend>
                                <div class="control is-block">

                                    <p class="help">When does the poll close or expire?</p>

                                    <div class="field is-marginless py-1">
                                        <div class="control">
                                            <label class="xero-radio">
                                                <xero-radio @change=" (data) => {pollExpiration = data;} " name="expiration" id="expiration" :checked=" ! poll || poll.expiration === 'Never' ? 'checked' : '' " value="Never"></xero-radio>
                                                <span></span>
                                                Never
                                            </label>
                                        </div>
                                    </div>


                                    <div class="field is-marginless py-1 is-grouped">
                                        <div class="control">
                                            <label class="xero-radio">
                                                <xero-radio @change=" (data) => {pollExpiration = data;} " name="expiration" :checked=" poll && poll.expiration === 'Date' ? 'checked' : false " value="Date"></xero-radio>
                                                <span></span>
                                                At the end of the day on:
                                            </label>
                                        </div>
                                        <div class="control has-small-datepicker">
                                            <VueCtkDateTimePicker
                                                v-model="pollExpirationDate"
                                                :only-date="true"
                                                formatted="ll"
                                                format="YYYY-MM-DD HH:mm:ss" />
                                            <input type="hidden" name="poll-expiration-Date" :value=" $outputDate(pollExpirationDate, 'YYYY-MM-DD') " />
                                        </div>
                                    </div>

                                    <div class="py-1">
                                        <div class="field is-marginless is-grouped">
                                            <div class="control">
                                                <label class="xero-radio">
                                                    <xero-radio @change=" (data) => {pollExpiration = data;} " name="expiration" :checked=" poll && poll.expiration === 'After' ? 'checked' : false " value="After"></xero-radio>
                                                    <span></span>
                                                    After XX votes are collected:
                                                </label>
                                            </div>
                                            <div class="control">
                                                <xero-input name="poll-expiration-After" type="number" min="1" :value=" poll && poll.expiration === 'After' ? poll.expiration_meta : 10 " class="input is-small"></xero-input>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="field is-marginless py-1 is-grouped">
                                        <div class="control">
                                            <label class="xero-radio">
                                                <xero-radio @change=" (data) => {pollExpiration = data;} " name="expiration" :checked=" poll && poll.expiration === 'Goal' ? 'checked' : false " value="Goal"></xero-radio>
                                                <span></span>
                                                Once a section reaches XX votes:
                                            </label>
                                        </div>
                                        <div class="control">
                                            <xero-input name="poll-expiration-Goal" type="number" min="1" :value=" poll && poll.expiration === 'Goal' ? poll.expiration_meta : 10 " class="input is-small"></xero-input>
                                        </div>
                                    </div>
                                </div>
                            </fieldset>

                            <fieldset class="field my-4">
                                <legend class="label">
                                    <label for="showResults" class="label">Poll Results</label>
                                </legend>
                                <div class="control is-block">
                                    <p class="help">When should the results of the poll be displayed to everyone?</p>

                                    <div class="field is-marginless py-1">
                                        <div class="control">
                                            <label class="xero-radio">
                                                <xero-radio name="showResults" id="showResults" :checked=" ! poll || poll.showResults === 'Never' ? 'checked' : false " value="Never"></xero-radio>
                                                <span></span>
                                                Never
                                            </label>
                                        </div>
                                    </div>


                                    <div class="field is-marginless py-1">
                                        <div class="control">
                                            <label class="xero-radio">
                                                <xero-radio name="showResults" :checked=" poll && poll.showResults === 'Always' ? 'checked' : false " value="Always"></xero-radio>
                                                <span></span>
                                                Always
                                            </label>
                                        </div>
                                    </div>


                                    <div class="field is-marginless py-1">
                                        <div class="control">
                                            <label class="xero-radio">
                                                <xero-radio name="showResults" :checked=" poll && poll.showResults === 'After' ? 'checked' : false " value="After"></xero-radio>
                                                <span></span>
                                                After they vote
                                            </label>
                                        </div>
                                    </div>


                                    <div class="field is-marginless py-1">
                                        <div class="control">
                                            <label class="xero-radio">
                                                <xero-radio name="showResults" :checked=" poll && poll.showResults === 'Close' ? 'checked' : false " value="Close"></xero-radio>
                                                <span></span>
                                                After the poll closes
                                            </label>
                                        </div>
                                    </div>


                                </div>
                            </fieldset>

                            <fieldset class="field my-4">
                                <legend class="label">
                                    <label for="changeVote" class="label">Change Votes?</label>
                                </legend>
                                <div class="control is-block">
                                    <p class="help">Can the user retract or change their vote?</p>

                                    <div class="field is-marginless py-1">
                                        <div class="control">
                                            <label class="xero-radio">
                                                <xero-radio name="changeVote" id="changeVote" :checked=" poll && poll.changeVote === 1 ? 'checked' : false " value="1"></xero-radio>                                                <span></span>
                                                Yes
                                            </label>
                                        </div>
                                    </div>


                                    <div class="field is-marginless py-1">
                                        <div class="control">
                                            <label class="xero-radio">
                                                <xero-radio name="changeVote" :checked=" !poll || poll.changeVote === 0 ? 'checked' : false " value="0"></xero-radio>
                                                <span></span>
                                                No
                                            </label>
                                        </div>
                                    </div>

                                </div>
                            </fieldset>

                        </div>
                    </div>
                    <div class="is-divider"></div>
                </div>
            </div>
        </div>
    </div>


</template>


<script>
    export default {
        name: 'Add-Poll',
        props: {
            poll: {
                type: Object,
                required: false
            },
        },
        data() {
            return {
                xPoll: this.poll || {},
                inputs: ['', '', ''],
                opened: '',
                advancedOptionsOpened: '',
                pollExpiration: 'Never',
                pollExpirationDate: this.poll && this.poll.expiration === 'Date' ? this.$outputDate(new Date(this.poll.expiration_meta), 'YYYY-MM-DD HH:mm:ss') : this.$moment().add('3', 'days').format('YYYY-MM-DD HH:mm:ss')
            }
        },
        methods: {
            addPollOption: function() {
                this.inputs.push('');
            },
            deleteOption(index) {
                this.inputs.splice(index, 1);
            },
        },
        mounted() {
            if(this.$store.state.old.PollOptions) {
                if(this.$store.state.old.PollOptions.length) {
                    this.inputs = this.$store.state.old.PollOptions;
                }
            }
        },
    }
</script>

<style scoped>
    .help {
        font-style: italic;
    }
    .field {
        margin-top: 1.5rem;
    }
    .poll-creation-wrapper {
        height: 0;
        overflow: hidden;
    }
    .poll-creation-wrapper.is-opened {
        height: auto;
    }

    .advanced-options-wrapper {
        height: 0;
        overflow: hidden;
    }
    .advanced-options-wrapper.is-opened {
        height: auto;
    }
    .has-small-datepicker > div {
        display: inline-block;
    }
</style>

<style>
    .has-small-datepicker .vmdtp_label {
        font-size: 0.75rem;
    }
    .has-small-datepicker .vmdtp_label .vmdtp_input {
        width: auto;
        padding: 6px 7px;
        border: 1px solid #dbdbdb;
        border-radius: 2px;
        font-size: 0.75rem;
        box-shadow: inset 0 0.0625em 0.125em rgb(10 10 10 / 5%);
    }

</style>
